import { ActionWithPayload } from "@obg/ngrx-utils";
import { omit } from "lodash-es";

import { GAME_VARIANT_ACTION_TYPE } from "./game-variant.action";
import {
	BaseProviderParams,
	GameSettings,
	GameVariantDetail,
	GameVariantState,
	GetGameVariantParams,
} from "./game-variant.model";

const INITIAL_STATE: GameVariantState = {
	isBusy: false,
	gameVariants: {},
	gameSettings: {},
};

export function gameVariantReducer(state = INITIAL_STATE, action: ActionWithPayload): GameVariantState {
	switch (action.type) {
		case GAME_VARIANT_ACTION_TYPE.get: {
			const payload = action.payload as GetGameVariantParams;
			const gameVariants: Record<string, GameVariantDetail<BaseProviderParams>> = omit(
				state.gameVariants,
				payload.jurisdiction ? `${payload.jurisdiction}-${payload.variantId}` : payload.variantId
			);

			return {
				...state,
				gameVariants,
				isBusy: true,
			};
		}
		case GAME_VARIANT_ACTION_TYPE.getFail: {
			return { ...state, isBusy: false };
		}
		case GAME_VARIANT_ACTION_TYPE.getSuccess: {
			const payload = action.payload;
			const gameVariant: Record<string, GameVariantDetail<BaseProviderParams>> = {};

			// todo: API should handle this inconsistency. Some gameVariants are not jurisdiction specific.
			const id = payload.jurisdiction
				? `${payload.jurisdiction}-${payload.gameVariant.id}`
				: payload.gameVariant.id;

			gameVariant[id] = payload.gameVariant;

			return Object.assign({}, state, {
				gameVariants: Object.assign({}, state.gameVariants, gameVariant),
				isBusy: false,
			});
		}
		case GAME_VARIANT_ACTION_TYPE.getSettingsSuccess: {
			const payload = action.payload;
			const gameSettings: Record<string, GameSettings> = {};
			const id = payload.gameSettings.gameId;

			gameSettings[id] = payload.gameSettings;

			return Object.assign({}, state, {
				...state,
				gameSettings: Object.assign({}, state.gameSettings, gameSettings),
				isBusy: false,
			});
		}

		case GAME_VARIANT_ACTION_TYPE.clear: {
			return INITIAL_STATE;
		}
		default:
			return state;
	}
}
